<template>
    <div 
        v-if="$_matchedJobs.length" 
        class="af-jobview-container afu-bg-secondary afu-py-0 md:afu-pt-sliderWrapper--top md:afu-pb-sliderWrapper--bottom afu-overflow-hidden afu-mt-3 md:afu-mt-15 md:afu-mb-0"
    >
        <div class="af-jobview-inner-container afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto">
            <div class="af-jobview-sidebar-header afu-my-9 md:afu-my-4 afu-mb-3 afu-text-lg afu-text-center afu-font-bold afu-text-gray-600 afu-flex afu-justify-between afu-px-4 md:afu-px-0">
                <h3 class="afu-text-white af-text--8xl afu-my-0">
                    {{ $t('job_view.other_jobs') }}
                </h3>
                <div>
                    <div class="af-matched-jobs-nav">
                        <a class="af-matched-jobs-nav--left wow animate__animated animate__fadeInUp afu-p-3 afu-bg-secondary-dark afu-rounded-round afu-border-none afu-inline-flex">
                            <svg 
                                width="14"
                                height="14" 
                                viewBox="0 0 14 14" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path 
                                    d="M8.47577 12.5242L3.99523 8.04368H14V5.95631H3.99523L8.47577 1.47577L7 0L0 7L7 14L8.47577 12.5242Z" 
                                    fill="white"
                                />
                            </svg>
                        </a>
                        <a class="af-matched-jobs-nav--right wow animate__animated animate__fadeInUp afu-p-3 afu-bg-secondary-dark afu-rounded-round afu-border-none afu-ml-2 afu-inline-flex">
                            <svg 
                                width="14" 
                                height="14" 
                                viewBox="0 0 14 14" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path 
                                    d="M5.52423 12.5242L7 14L14 7L7 0L5.52423 1.47577L10.0048 5.95631H0V8.04368H10.0048L5.52423 12.5242Z" 
                                    fill="white"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="$_matchedJobs.length"
            class="af-similar-jobs afu-mt-10 afu-mb-4 swiper-container-horizontal afu-max-w-screen-xl afu-ml-auto afu-mr-auto"
            id="af-similar-jobs"
        >
            <div class="swiper-wrapper">
                <div
                    v-for="job in $_matchedJobs"
                    :key="job.id"
                    class="af-similar-job-item afu-p-6 afu-mb-4 afu-rounded-card afu-bg-white swiper-slide afu-shadow-lg afu-flex afu-flex-col afu-relative"
                >
                    <a
                        :href="jobViewUrl(job)"
                        class="afu-absolute afu-w-full afu-h-full afu-z-0 afu-left-0 afu-top-0"
                    />
                    <div class="af-similar-job-date af-text--base afu-text-neutral-dark afu-mb-2">
                        {{ $t('job_view.posted_on') }} {{ job.activates_at | dateFormat('MMM YYYY') }}
                    </div>
                    <div class="af-similar-job-title af-text--4xl afu-flex afu-flex-col">
                        <a
                            :href="jobViewUrl(job)"
                            class="afu-text-black afu-font-semibold afu-no-underline afu-relative"
                        >
                            <span v-html="job.job_title" />
                        </a>
                    </div>
                    <div class="af-similar-job-features af-text--base afu-flex afu-flex-col afu-mt-2 md:afu-mt-2 afu-mb-4 afu-text-secondary afu-font-bold">
                        <span>
                            {{ job.location_label }}
                        </span>
                        <span
                            v-if="!parseInt(job.pay_is_hidden)"
                            class="af-pay-range"
                        >
                            <span v-html="getMinMaxLabel(job)"></span>
                        </span>
                        <span
                            v-if="!parseInt(job.pay_is_hidden)"
                            class="af-pay-description"
                        >
                            {{ job.pay_description }}
                        </span>
                        <span
                            v-if="showCustomAttribute(job, 1)"
                        >
                            {{ getCustomAttributeValue(job, 1) }}
                        </span>
                        <span
                            v-if=" showCustomAttribute(job, 2)"
                        >
                            {{ getCustomAttributeValue(job, 2) }}
                        </span>
                        <span
                            v-if="showCustomAttribute(job, 3)"
                        >
                            {{ getCustomAttributeValue(job, 3) }}
                        </span>
                        <span
                            v-if="showCustomAttribute(job, 4)"
                        >
                            {{ getCustomAttributeValue(job, 4) }}
                        </span>
                    </div>

                    <div class="af-similar-job-details af-text--base afu-text-black afu-mb-5">
                        <template v-if="job.job_bullets && job.job_bullets.length">
                            <ul
                                class="afu-list-disc afu-m-0 afu-p-0 afu-ml-4 afu-mb-4 afu-mt-5"
                            >
                                <li
                                    v-for="(job_bullet, index) in job.job_bullets"
                                    :key="`${job.uuid}_${index}`"
                                    class="afu-mb-1"
                                >
                                    {{ job_bullet }}
                                </li>
                            </ul>
                        </template>
                        <template v-if="job.short_description && job.short_description.length">
                            <div class="short_description"
                                 v-html="job.short_description.length > 150 ? job.short_description.substring(0, 150) + ' ...' : job.short_description" />
                        </template>
                        <template v-else>
                            <div class="job_description"
                                 v-html="job.job_description.length > 150 ? job.job_description.substring(0, 150) + ' ...' : job.job_description" />
                        </template>
                    </div>

                    <div class="af-save-job-mini afu-mb-5 afu-mt-auto">
                        <SaveJob
                            :job-uuid="job.uuid"
                            class="afu-relative"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import { slugify, payMinMaxLabel, getJobViewBaseUrl } from '@/utils/helpers';
    import Filters from '@/components/Utils/Filters';
    import Swiper from 'swiper';

    import SaveJob from './Actions/SaveJob';
    // import SwiperCore, { Navigation, Pagination } from 'swiper/core';
    // import 'swiper/swiper-bundle.css';
    // eslint-disable-next-line import/no-unresolved
    // import 'swiper/css/swiper.css';

    export default {
        name: 'JobViewMatchedJobs',

        components: {
            SaveJob,
        },

        mixins: [Filters],

        computed: {
            ...mapState({
                $_matchedJobs: state => state.job.matchedJobs,
            }),
        },

        mounted() {
            this.initSwiper();
        },

        methods: {
            jobViewUrl(job) {
                return `${getJobViewBaseUrl()}/${slugify(job.job_title)}/${job.uuid}/`;
            },

            getMinMaxLabel(job) {
                return payMinMaxLabel(job, this.$t('global.currency_symbol'));
            },

            getCustomAttributeValue(job, index) {
                return job[`applyflow_custom_${index}_details`] ? job[`applyflow_custom_${index}_details`][0].value : '';
            },

            showCustomAttribute(job, index) {
                return window?.afConfig[`applyflow_custom_${index}_show`] === 'Yes' && job[`applyflow_custom_${index}_details`];
            },
            initSwiper() {
                if (Swiper) {
                    var int = setInterval(function(){
                        if(document.getElementById('af-similar-jobs')) {
                            var isInfinite = false;
                            if(document.getElementsByClassName('af-similar-job-item').length > 3) {
                                isInfinite = true;
                            }
                            new Swiper('.af-similar-jobs', {
                                speed: 400,
                                slidesPerView: 1.4,
                                spaceBetween: 20,
                                centeredSlides: true,
                                noSwiping: true,
                                loop: isInfinite,
                                infinite: isInfinite,
                                watchSlidesVisibility: true,
                                navigation: {
                                    nextEl: '.af-matched-jobs-nav--right',
                                    prevEl: '.af-matched-jobs-nav--left',
                                },
                                breakpoints: {
                                    // when window width is >= 768px
                                    768: {
                                        loop: isInfinite,
                                        centeredSlides: false,
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                        noSwiping: false,
                                    },
                                    1200: {
                                        loop: isInfinite,
                                        centeredSlides: false,
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                        noSwiping: false,
                                    },
                                },
                            });
                            clearInterval(int);
                        }
                    }, 50);
                }
            },
        },
    };
</script>
<style>
    .af-app .af-similar-job-item.swiper-slide {
        height: auto;
    }

    .swiper-slide {
        opacity: 0.3;
    }

    .swiper-slide-active {
        opacity: 1;
    }

    @media screen and (min-width: 768px) {
        .swiper-slide {
            opacity: 0.3;
        }

        .swiper-slide-visible {
            opacity: 1;
        }
    }
</style>